import { ArrowRight, Check } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ModuleCard = (props) => {
  const Icon = props.icon;
  const title = props.title;
  const description = props.description;
  const features = props.features || [];
  const users = props.users || "";
  const inputs = props.inputs || "";
  const outputs = props.outputs || "";
  const link = props.link;
  const variant = props.variant || "default";
  const className = props.className || "";

  const sizeClasses = {
    default: "",
    large: "md:col-span-2 md:row-span-2",
    wide: "md:col-span-2"
  };

  return (
    <div 
      className={`card-feature ${sizeClasses[variant]} ${className}`}
      data-testid={`module-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-start gap-4 mb-4">
        <div className="icon-container flex-shrink-0">
          {Icon && <Icon className="w-6 h-6" />}
        </div>
        <div>
          <h3 className="text-xl font-bold text-slate-900">{title}</h3>
          {users && (
            <p className="text-sm text-[#C8A24A] font-medium mt-1">Used by: {users}</p>
          )}
        </div>
      </div>
      
      <p className="text-slate-600 leading-relaxed mb-6">{description}</p>
      
      {features.length > 0 && (
        <ul className="space-y-2 mb-6">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-slate-600">
              <Check className="w-4 h-4 text-[#1F7A3A] mt-0.5 flex-shrink-0" />
              {feature}
            </li>
          ))}
        </ul>
      )}

      {(inputs || outputs) && (
        <div className="border-t border-slate-100 pt-4 mt-auto">
          {inputs && (
            <p className="text-xs text-slate-500 mb-1">
              <span className="font-medium">Inputs:</span> {inputs}
            </p>
          )}
          {outputs && (
            <p className="text-xs text-slate-500">
              <span className="font-medium">Outputs:</span> {outputs}
            </p>
          )}
        </div>
      )}

      {link && (
        <Link 
          to={link}
          className="mt-4 flex items-center gap-2 text-sm font-medium text-[#1F7A3A] hover:text-[#145A2A] group"
        >
          Learn more
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1" style={{ transition: 'transform 0.2s' }} />
        </Link>
      )}
    </div>
  );
};
